import React from "react";
import { Menu } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import { version } from "../../../package.json";
import styles from "./styles.module.scss";
import messages from "./messages";

const ApexFooter = () => {
  const versionText = `ver ${version}`;
  return (
    <Menu className={styles.appFooter} id="appFooter">
      <Menu.Item position="left">
        <FormattedMessage
          {...messages.copyright}
          children={(msg) => <span id={styles.copyright}>{msg}</span>}
        />
      </Menu.Item>
      <Menu.Item position="right">
        <span id={styles.appVersion}>{versionText}</span>
      </Menu.Item>
    </Menu>
  );
};

export default ApexFooter;
